import { render, staticRenderFns } from "./SfGroupedProduct.vue?vue&type=template&id=7b568cef&"
import script from "./SfGroupedProduct.vue?vue&type=script&lang=js&"
export * from "./SfGroupedProduct.vue?vue&type=script&lang=js&"
import style0 from "./SfGroupedProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports